import * as Yup from "yup";

export const aircraftsDetailsValidationSchema = Yup.object()
  .shape({
    make: Yup.string().required("Required"),
    model: Yup.string().required("Required"),
    tailNumber: Yup.string()
      .required("Required")
      .min(1, "Expected minimum of 1 character")
      .max(30, "Expected maximum of 30 characters")
      .matches(/^[a-zA-Z0-9_-]+$/, {
        message: 'Expected alphanumeric characters, "-" and "_" only',
        excludeEmptyString: true,
      }),
    serialNumber: Yup.string()
      .required("Required")
      .min(1, "Expected minimum of 1 character")
      .max(30, "Expected maximum of 30 characters")
      .matches(/^[a-zA-Z0-9_-]+$/, {
        message: 'Expected alphanumeric characters, "-" and "_" only',
        excludeEmptyString: true,
      }),
  })
  .required();
